<template>
  <div class="warp-box">
    <div class="features-container">
      <div class="features-title">
        <div class="flex-align-justify-left title">ZZ经营助手</div>
        <div class="flex-align-justify-left title">赋能商业场景，驱动电竞生态升级</div>
        <div class="tips">
          面向网吧、电竞酒店等商业场景，我们深度整合腾讯、网易等头部游戏资源，以全链路运营管理工具与创新游戏生态服务，助力商户提升用户粘性、优化运营效率、实现营收增长。
        </div>
      </div>
      <div class="container-content">
        <!-- 左侧导航 -->
        <div class="features-nav">
          <div
            class="nav-item"
            :class="{ active: activeTab === 0 }"
            @click="activeTab = 0"
          >
            <img class="image" src="../assets/features/task.png" alt="">
            游戏官方任务
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 1 }"
            @click="activeTab = 1"
          >
            <img class="image" src="../assets/features/store.png" alt="">
            门店活动任务
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 2 }"
            @click="activeTab = 2"
          >
            <img class="image" src="../assets/features/event.png" alt="">
            赛事中心
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 3 }"
            @click="activeTab = 3"
          >
            <img class="image" src="../assets/features/peripherals.png" alt="">
            外设驱动合集
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 4 }"
            @click="activeTab = 4"
          >
            <img class="image" src="../assets/features/file.png" alt="">
            用户游戏存档
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 5 }"
            @click="activeTab = 5"
          >
            <img class="image" src="../assets/features/cloud.png" alt="">
            用户个人云盘
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 6 }"
            @click="activeTab = 6"
          >
            <img class="image" src="../assets/features/business.png" alt="">
            商户管理后台
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 7 }"
            @click="activeTab = 7"
          >
            <img class="image" src="../assets/features/small.png" alt="">
            公众号/小程序
          </div>
          <div
            class="nav-item"
            :class="{ active: activeTab === 8 }"
            @click="activeTab = 8"
          >
            <img class="image" src="../assets/features/cash.png" alt="">
            收银控制台
          </div>
        </div>

        <!-- 右侧内容 -->
        <div class="features-content">
          <div class="content-area">
            <!-- 智能管理系统 -->
            <div v-if="activeTab === 0" class="content-item">
              <features-title title="游戏官方任务" text="ZZ经营助手与腾讯与网易游戏官方合作，随时提供各类游戏丰富官方任务，所有任务门店可配置额外门店奖品"></features-title>
              <div class="feature-list">
                <img src="../assets/home/容器 794@2x.png" alt="游戏官方任务展示">
              </div>
            </div>
            <!-- 深度游戏生态合作 -->
            <div v-if="activeTab === 1" class="content-item">
              <features-title title="门店活动任务" text="丰富的门店用户活跃任务，门店可以针对性配置各类奖品，提高用户积极性"></features-title>
              <div class="feature-list">
                <img src="../assets/home/容器 790@2x.png" alt="门店活动任务展示">
              </div>
            </div>

            <!-- 赛事中心 -->
            <div v-if="activeTab === 2" class="content-item">
              <features-title title="赛事中心" text="门店可通过后台自主创建发起自发赛或娱乐赛，ZZ经营助手官方每月都会发起面向所有用户的平台赛"></features-title>
              <div class="feature-list">
                <img style="width: 900px" src="../assets/home/容器 802@2x.png" alt="赛事中心展示">
              </div>
            </div>

            <!-- 外设驱动合集 -->
            <div v-if="activeTab === 3" class="content-item">
              <features-title title="外设驱动合集" text="ZZ经营助手提供当前各类热门外设驱动合集功能，门店可自主选择是否启用"></features-title>
              <div class="feature-list">
                <img src="../assets/home/组 791@2x (1).png" alt="外设驱动合集展示">
              </div>
            </div>

            <!-- 用户游戏存档 -->
            <div v-if="activeTab === 4" class="content-item">
              <features-title title="用户游戏存档" text="登录ZZ经营助手，游戏自动存档，再也不需要担心游戏存档丢失"></features-title>
              <div class="feature-list">
                <img style="width: 734px" src="../assets/home/容器 56280@2x (1).png" alt="用户游戏存档展示">
              </div>
            </div>
            <!-- 用户个人云盘 -->
            <div v-if="activeTab === 5" class="content-item">
              <features-title title="用户个人云盘" text="每位用户登录后默认拥有10G云存储空间，免费上传，安装ZZ经营助手所有门店登录账号即可使用"></features-title>
              <div class="feature-list" style="text-align: center">
                <img style="width: 734px" src="../assets/home/容器 801@2x (1).png" alt="用户个人云盘展示">
              </div>
            </div>
            <!-- 商户管理后台 -->
            <div v-if="activeTab === 6" class="content-item">
              <features-title title="商户管理后台" text="ZZ经营助手商户管理后台，提供统计门店各类数据，客户端功能自定义配置"></features-title>
              <div class="feature-list" style="text-align: center">
                <img src="../assets/home/容器 803@2x.png" alt="商户管理后台展示">
              </div>
            </div>
            <!-- 公众号/小程序 -->
            <div v-if="activeTab === 7" class="content-item">
              <features-title title="公众号/小程序" text="ZZ经营助手公众号、商户管理后台移动端、附近合作门店地图导航搜索"></features-title>
              <div class="feature-list" style="text-align: center">
                <img src="../assets/组 804@2x (1).png" alt="公众号及小程序展示">
              </div>
            </div>
            <!-- 收银控制台 -->
            <div v-if="activeTab === 8" class="content-item">
              <features-title title="收银控制台" text="收银控制台：网管呼叫记录、奖品核销、商品管理与订单处理、员工交接班"></features-title>
              <div class="feature-list" style="text-align: center">
                <img src="../assets/home/容器 805@2x.png" alt="收银控制台展示">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeaturesTitle from '@/components/features/header-title.vue'
export default {
  name: 'Features',
  components: {
    FeaturesTitle
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>
.warp-box {
  background-image: url("@/assets/function/function.png");
  background-repeat: no-repeat;
  background-size: cover; /* 保留原始比例 */
  background-color: #f2f2f2;
  width: 100%;
}

.features-container {
  max-width: 1200px;
  margin: 0 auto;
}
.container-content {
  display: flex;
  padding:20px 0;
}
.features-nav {
  width: 171px;
  padding: 10px;
  background: #ffffff;
}

.nav-item {
  width: 151px;
  height: 48px;
  margin-top: 10px;
  line-height: 48px;
  background: #F4F8FF;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #636C98;
  padding-left: 5px;
  cursor: pointer;
  border-radius: 14px 14px 14px 14px;
  border: 2px solid transparent;
}

.nav-item:hover {
  background: #B2E2FF;
  color: #444773;
}

.nav-item.active {
  background: #B2E2FF;
  color: #444773;
}

.features-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-area {
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
  height: 100%;
  border-radius: 14px 14px 14px 14px;
  margin-left: 20px;
}

.content-item {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.2;
}

.content-desc {
  font-size: 16px;
  color: #5a6c7d;
  line-height: 1.8;
  margin-bottom: 30px;
  text-align: justify;
}

.feature-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 0 30px 24px;
}
.feature-list img {
  width: 100%;
  max-width: 100%;
  height: 500px;
  object-fit: contain;
  object-position: center top;
  padding-right: 12px;
}
.title {
  margin-top: 20px;
  height: 28px;
  font-weight: 700;
  font-size: 28px;
  color: #1C2666;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.features-title {
  padding-top: 29px;
}
.tips{
  font-weight: 400;
  margin-top: 20px;
  font-size: 18px;
  color: #1C2666;
  line-height: 26px;
  text-align: left;
}
.image {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
